import * as React from "react";
const SvgPentagon = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m2 9 4 12h12l4-12-10-7z",
  fill: "currentColor"
}));
export default SvgPentagon;